import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import { Loja } from '../../common/types/Loja'
import { adicionarBuscaRecente } from '@/shareds/buscasRecentes'
import { ResultadoBusca } from '../../common/types/Busca'
import { useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemLoja',
  props: {
	item: { type: Object as PropType<Loja>, required: true },
},
  setup(__props) {

const props = __props;



const router = useRouter()

function onClickItemBusca() {
	adicionarBuscaRecente(props.item as ResultadoBusca)
	router.push({
		name: 'detalhar-loja',
		params: { id: props.item._id },
	})
}

return { __sfc: true,props, router, onClickItemBusca }
}

})